<template>
  <div>
    <FITModal ref="confirmClaimModal" reference="modal" :title="modalTitle" @click="onClickModal">
      <div slot="body">
        <span v-html="modalBody"></span>
      </div>
    </FITModal>
    <b-row align-h="center" class="mt-0 pt-0">
      <div class="w-75">
        <b-row align-v="center">
          <b-col cols="12">
            <FITWorkflowProgressbar ref="progressBar" :startingIndex="nextStep" :steps="workflow"></FITWorkflowProgressbar>
          </b-col>
          <b-col cols="6">
            <FITAlert ref="alert" :alertContent="alertContent" :variant="alertParams.variant" :alertSec="3" :dismissible="true"></FITAlert>
          </b-col>
          <b-col  v-if="permissionLevel < 3.5" cols="auto" class="ml-auto">
            <FITButton v-if="this.nextStep == 0" :text="$t( 'general.CURD.next')" variant="primary" @click="onClickBtn('next')"></FITButton>
            <FITButton  v-if="this.nextStep > 0 && !isLocked" :text="$t( 'general.CURD.save')" variant="warning" @click="onClickBtn('edit')" class="mr-3"></FITButton>
            <FITButton v-if="this.nextStep == 2" :text="$t('general.CURD.complete')" variant="primary" @click="onClickBtn('complete')"></FITButton>
            <template v-if="this.nextStep == 1">
              <FITButton class="mr-3" :text="$t('general.CURD.reject')" variant="danger" faIcon="fa-times-circle" @click="onClickBtn('reject')"></FITButton>
              <FITButton :text="$t('general.CURD.approve')" variant="success" faIcon="fa-check-circle" @click="onClickBtn('approve')"></FITButton>
            </template>
          </b-col>
        </b-row>
        <FITOutstandingRequirement v-if="nextStep==1" v-bind="orProps"></FITOutstandingRequirement>
        <FITFormCard>
          <div slot="header">
            <b-row align-v="center">
              <b-col cols="6">
                <h4>{{header}}</h4></b-col>
              <b-col cols="auto" class="ml-auto">
                <h3 v-if="nextStep > 0 && permissionLevel < 3.5" @click="changeLockStatus" style="cursor:pointer">
                  <i v-if="isLocked" class="fa fa-lock"></i>
                  <i v-else class="fa fa-unlock "></i>
                </h3>
              </b-col>
            </b-row>
          </div>
          <div slot="formBody">
            <template>
              <b-row>
                <b-col cols="6">
                  <FITTextInput :label="$t('osm.claim.policy')" :disabled="true" :width="columnWidth" v-model="policyName"></FITTextInput>
                  <FITSelect field="claimType" :rule="{required:true}" vuexObject="applyClaim" @validation="setValidationResult('claimType',$event)" :label="$t('osm.claim.claimType')" :disabled="nextStep >= 1 && isLocked" :width="columnWidth" v-model="form.claimType" :options="claimTypeList"></FITSelect>
                  <FITDatePicker field="claimRequestDate" :rule="{required:true}" vuexObject="applyClaim" :label="$t('osm.claim.claimRequestDate')" @validation="setValidationResult('claimRequestDate',$event)" :disabled="nextStep > 0 && isLocked" :width="columnWidth" v-model="form.claimRequestDate"></FITDatePicker>
                </b-col>
                <b-col cols="6">
                  <FITTextInput field="policyType" :label="$t('osm.claim.policyType')"  :disabled="true" :width="columnWidth" :value="policyType"></FITTextInput>
                  <FITTextInput field="expectedClaimAmount" :rule="{required:false, decimal:true}"   vuexObject="applyClaim" :label="$t('osm.claim.expectedClaimAmount')"  @validation="setValidationResult('expectedClaimAmount',$event)" :disabled="nextStep > 0 && isLocked" :width="columnWidth" v-model="form.expectedClaimAmount"></FITTextInput>
                </b-col>
                <b-col cols="12">
                  <FITTextarea :label="$t('osm.claim.remark')" :width="columnWidth + 2" :disabled="nextStep > 0 && isLocked" v-model="form.remark"></FITTextarea>
                  <FITWorkflowFileUpload ref="fitFileUpload" :uploadedFiles="uploadedFiles" :disabled="nextStep > 0 && isLocked"></FITWorkflowFileUpload>
                </b-col>
              </b-row>
              <template v-if="nextStep >= 1 && permissionLevel < 3.5">
                <hr>
                <b-row>
                  <b-col cols="6">
                    <FITDatePicker  :rule="{required:true}" vuexObject="pending" @validation="setValidationResult('claimResponseDate',$event)" :label="$t('osm.claim.claimResponseDate')" :disabled="nextStep > 1 && isLocked" :width="columnWidth" v-model="pendingForm.claimResponseDate"></FITDatePicker>
                  </b-col>
                </b-row>
              </template>
              <template v-if="nextStep > 1 && permissionLevel < 3.5">
                <hr>
                <h5>{{$t('osm.claim.claimResult')}}</h5>
                <template v-for="(item,index) in claimResults">
                  <b-row align-v="center">
                    <b-col cols="2" class="text-center">
                      <h4>{{index + 1}}.</h4>
                    </b-col>
                    <b-col cols="10">
                      <b-row>
                        <b-col cols="6">
                          <FITDatePicker v-bind="claimResultRules.claimIssueDate" @validation="setValidationResult('claimIssueDate',$event)" :label="$t('osm.claim.claimIssueDate')" :width="columnWidth" v-model="claimResults[index].claimIssueDate"></FITDatePicker>
                          <FITSelect v-bind="claimResultRules.claimPaymentMethod" @validation="setValidationResult('claimPaymentMethod',$event)" :label="$t('osm.claim.claimPaymentMethod')" :width="columnWidth" v-model="claimResults[index].claimPaymentMethod" :options="claimPaymentMethodList"></FITSelect>
                          <FITDatePicker v-bind="claimResultRules.companyReceiveDate" @validation="setValidationResult('companyReceiveDate',$event)" :label="$t('osm.claim.companyReceiveDate')" :width="columnWidth" v-model="claimResults[index].companyReceiveDate"></FITDatePicker>
                          <FITDatePicker v-bind="claimResultRules.agentReceiveDate" @validation="setValidationResult('agentReceiveDate',$event)" :label="$t('osm.claim.agentReceiveDate')" :width="columnWidth" v-model="claimResults[index].agentReceiveDate"></FITDatePicker>
                          <FITDatePicker v-bind="claimResultRules.customerReceiveDate" @validation="setValidationResult('customerReceiveDate',$event)" :label="$t('osm.claim.customerReceiveDate')" :width="columnWidth" v-model="claimResults[index].customerReceiveDate"></FITDatePicker>
                        </b-col>
                        <b-col cols="6">
                          <FITTextInput v-bind="claimResultRules.claimAmount" @validation="setValidationResult('claimAmount',$event)" :label="$t('osm.claim.claimAmount')" type="currency" :width="columnWidth" v-model="claimResults[index].claimAmount"></FITTextInput>
                          <FITTextInput v-bind="claimResultRules.claimReference" @validation="setValidationResult('claimReference',$event)" :label="$t('osm.claim.claimReference')" :width="columnWidth" v-model="claimResults[index].claimReference"></FITTextInput>
                          <FITTextarea :label="$t('osm.claim.remark')" :width="columnWidth" v-model="claimResults[index].remark"></FITTextarea>
                          <b-row align-v="center">
                            <b-col cols="9">
                              <FITAlert :ref="`resultAlert${index}`" :alertContent="alertContent" :variant="alertParams.variant" :alertSec="3" :dismissible="true"></FITAlert>
                            </b-col>
                            <b-col cols="auto" class="ml-auto">
                              <FITButton v-if="item.ID" :text="$t('general.CURD.save')" variant="warning" @click="onClickEditResult('saveResult',index)"></FITButton>
                              <FITButton v-else :text="$t('general.add')" variant="primary" @click="onClickEditResult('createResult',index)"></FITButton>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                      <hr>
                    </b-col>
                  </b-row>
                </template>
              </template>
            </template>
          </div>
        </FITFormCard>
        <b-row>
          <b-col v-if="permissionLevel < 3.5" cols="auto" class="ml-auto">
            <FITButton v-if="this.nextStep == 0" :text="$t( 'general.CURD.next')" variant="primary" @click="onClickBtn('next')"></FITButton>
            <FITButton v-if="this.nextStep > 0 && !isLocked" :text="$t( 'general.CURD.save')" variant="warning" @click="onClickBtn('edit')" class="mr-3"></FITButton>
            <FITButton v-if="this.nextStep == 2" :text="$t('general.CURD.complete')" variant="primary" @click="onClickBtn('complete')"></FITButton>
            <template v-if="this.nextStep == 1">
              <FITButton class="mr-3" :text="$t('general.CURD.reject')" variant="danger" faIcon="fa-times-circle" @click="onClickBtn('reject')"></FITButton>
              <FITButton :text="$t('general.CURD.approve')" variant="success" faIcon="fa-check-circle" @click="onClickBtn('approve')"></FITButton>
            </template>
          </b-col>
        </b-row>
      </div>
    </b-row>
  </div>
</template>
<script type="text/javascript">
import Vue from 'vue'
import { mapGetters, mapState } from 'vuex'
import { FITFormCard, FITTextInput, FITTextarea, FITButton, FITModal, FITAutoSearch, FITSelect, FITDatePicker, FITWorkflowProgressbar, FITWorkflowFileUpload, FITAlert, FITOutstandingRequirement, FITValidationBus } from '@/components'

export default {
  name: 'ClaimCreate',
  components: {
    FITFormCard,
    FITTextInput,
    FITTextarea,
    FITButton,
    FITModal,
    FITAutoSearch,
    FITSelect,
    FITDatePicker,
    FITWorkflowProgressbar,
    FITWorkflowFileUpload,
    FITAlert,
    FITOutstandingRequirement
  },
  created() {
    this.$store.dispatch('getAllSelections', 'claim')
      .then((json) => {
        this.$store.commit({ type: 'Claim/setSelections', selections: json.data });
      })
      .catch((err) => {
        console.error(err);
      })

    if (this.detail) {
    if(this.detail.policyType){
      Vue.set(this.form, 'policyID', this.detail.policyID);
      Vue.set(this.form, 'policyType', this.detail.policyType);
      Vue.set(this, 'policyName', this.$options.filters.isUndifined(this.detail.productEnglishName) + ' ' + this.$options.filters.isUndifined(this.detail.productChineseName));
     }
      if (this.nextStep > 0) {   
        this.$store.dispatch('Claim/getClaimDetail', { ID: this.detail.ID }).then((json) => {
          // console.log(this.detail.ID);
          if(!this.detail.policyType){
          Vue.set(this.form, 'policyID', json.data.policyID);
          Vue.set(this.form, 'policyType',json.data.policyType);
          Vue.set(this, 'policyName', this.$options.filters.isUndifined(json.data.productEnglishName) + ' ' + this.$options.filters.isUndifined(json.data.productChineseName));
        }
          Vue.set(this.form, 'claimRequestDate', json.data.claimRequestDate);
          Vue.set(this.form, 'claimType', json.data.claimType);
          Vue.set(this.form, 'expectedClaimAmount', json.data.expectedClaimAmount);
          Vue.set(this.form, 'remark', json.data.remark);
          Vue.set(this.form, 'version', json.data.version);
          for (var i = 0; i < json.data.files.length; i++) {
            var fileName = json.data.files[i].documentName;
            var size = json.data.files[i].fileSize;
            var publicDocument = json.data.files[i].publicDocument;
            var remarks = json.data.files[i].remarks;
            var documentTag = json.data.files[i].documentTag;
            var ID  = json.data.files[i].ID;
            this.uploadedFiles.push({ fileName, size, publicDocument, remarks, documentTag,ID })
          }
          var cpy = JSON.parse(JSON.stringify(json.data.claimResults));
          Vue.set(this, 'claimResults', cpy);
          this.claimResults.push(JSON.parse(JSON.stringify(this.defaultClaimResult)));
        }).catch((err) => {});
      }
    }
    // this.getValidationRule(this.nextStep);
  },
  methods: {
    getValidationRule(index){
      FITValidationBus.$emit('reset',true);
      this.$store.commit('Validation/validationReset');
      this.$store.commit('Validation/setAlertMsg',{alertMsg: this.$t("validation.alertMsg.error")});
      // let action;
      //   switch(index){
      //     case 0:
      //     action = 'new';
      //     break;
      //     case 1:
      //     action = 'confirm';
      //     break;
      //     case 2:
      //     action = 'sendOut';
      //     break;
      //     default:
      //     action = 'new';
      //     break;
      //   }
      // this.$store.dispatch('Validation/getValidationRule',`/osm/claim/${action}`);
    },
    setValidationResult(key,value){
        // console.log(key,value);
      for (var vuexObject in this.validation) {
        if (!this.validation.hasOwnProperty(vuexObject)) continue;
        var obj = this.validation[vuexObject];
        for (var prop in obj) {
        if(!obj.hasOwnProperty(prop)) continue;
        if(prop == key){ 
          obj[prop] = value;
        }
    }
}
    },

    getValidationFinalResult(object){
      let results = this.validation[object];
      let finalResult = true;
      for (var key in results){
        finalResult = finalResult && results[key];
      }
      return finalResult;
    },
    changeLockStatus() {
      Vue.set(this, 'isLocked', !this.isLocked);
    },
    onClickEditResult(action, index) {
      Vue.set(this, 'action', action);
      Vue.set(this, 'selectedResult', index);
      FITValidationBus.$emit('dirty','claimResult');
      if(!this.getValidationFinalResult( 'claimResult')){
        alert(this.$t("validation.alertMsg.error"));
        return;
      }
      this.$refs.confirmClaimModal.openModal();
    },
    onCreateResult(index) {
      var form = { ...this.claimResults[index] };
      form.claimEventID = this.claimEventID;
      this.$store.dispatch('Claim/createClaimResult', form).then((json) => {
        Vue.set(this.claimResults[index], 'ID', json.data);
        this.claimResults.push(JSON.parse(JSON.stringify(this.defaultClaimResult)));
        this.$refs[`resultAlert${index}`][0].showAlert();
      }).catch((err) => {
        console.error(err);
      })
    },
    onSaveResult(index) {
      var form = { ...this.claimResults[index] };
      console.debug(this.claimResults);
      form.ID = this.claimResults[index].ID;
      this.$store.dispatch('Claim/editClaimResult', form).then((json) => {
        console.debug(this.$refs)
        console.debug(this.$refs[`resultAlert${index}`])
        this.$refs[`resultAlert${index}`][0].showAlert();
      }).catch((err) => {
        console.error(err);
      })

    },
    getTranslatedContent(type, key) {
      if (!key) {
        return 'N/A';
      }
      let result = this.getTranslatedArray(this.$i18n.locale, 'Claim', type)
        .filter((item) => {
          return item.value === key
        });
      if (result.length > 0) {
        return result[0].text;
      }
      return 'N/A';
    },
    onClickBtn(input) {
      Vue.set(this, 'action', input);
      let type = this.action;
      var vuexObject = "default";
      switch(this.action){
        case "next":
        vuexObject = "applyClaim";
        FITValidationBus.$emit('dirty',"applyClaim");
        break;
        case "reject":
        case "approve":
        vuexObject = "pending";
        FITValidationBus.$emit('dirty',"pending");
        break;
      }
      // FITValidationBus.$emit('dirty',vuexObject);

      if(!this.getValidationFinalResult(vuexObject)){
        alert(this.$t("validation.alertMsg.error"));
        return;
      }
     this.$refs.confirmClaimModal.openModal();

    },
    onApprove() {
      var filesData = this.uploadFile();
      var form = {
        ID: this.claimEventID,
        claimResponseDate: this.pendingForm.claimResponseDate,
        ...filesData
      }
      this.$store.dispatch('Claim/approveClaim', form).then((json) => {
          Vue.set(this.alertParams, 'content', this.$t('general.updateSuccess'));
          this.claimResults = [];
          this.claimResults.push(JSON.parse(JSON.stringify(this.defaultClaimResult)));
        this.$refs.alert.showAlert();
      }).catch((err) => {
        Vue.set(this.alertParams, 'content', this.$t('general.updateError'));
        this.$refs.alert.showAlert();
      })
    },
    onReject() {
      var filesData = this.uploadFile();
      var form = {
        ID: this.claimEventID,
        claimResponseDate: this.pendingForm.claimResponseDate,
        ...filesData
      }
      this.$store.dispatch('Claim/rejectClaim', form).then((json) => {
        this.$router.replace({ name: 'Claim List', params: { alertContent: this.$t('general.updateSuccess'), alertVariant: 'success' } });
      }).catch((err) => {
        Vue.set(this.alertParams, 'content', this.$t('general.updateError'));
        this.$refs.alert.showAlert();
      })
    },
    onComplete() {
      var form = { claimEventID: this.claimEventID }
      this.$store.dispatch('Claim/completeClaim', form).then((json) => {
        this.$router.replace({ name: 'Claim List', params: { alertContent: this.$t('general.updateSuccess'), alertVariant: 'success' } });
      }).catch((err) => {
        Vue.set(this.alertParams, 'content', this.$t('general.updateError'));
        this.$refs.alert.showAlert();
      })
    },
    onEdit() {
      var filesData = this.uploadFile();
      var form = {
        ID: this.claimEventID,
        ...this.form,
        ...this.pendingForm,
        ...filesData
      }
      this.$store.dispatch('Claim/editClaim', form).then((json) => {
        Vue.set(this.alertParams, 'content', this.$t('general.updateSuccess'));
        this.resetFileUpload();
        Vue.set(this, 'isLocked', true);
        this.$refs.alert.showAlert();
      }).catch((err) => {
        Vue.set(this.alertParams, 'content', this.$t('general.updateError'));
        this.$refs.alert.showAlert();
      });
    },
    onNext() {
      var filesData = this.uploadFile();
      var form = {
        ...this.form,
        ...filesData
      }
      this.$store.dispatch('Claim/createClaim', form).then((json) => {
        this.resetFileUpload();
      }).catch((err) => {});
    },
    resetFileUpload() {
      var newData = this.fileAttach;
      if (!newData.files) {
        return;
      }
      this.$refs.fitFileUpload.removeAllFile();
      for (var i = 0; i < newData.files.length; i++) {
        var fileName = newData.files[i].name;
        var size = newData.files[i].size;
        var publicDocument = newData.attachment.publicDocument[i];
        var remarks = newData.attachment.remarks[i];
        var documentTag = newData.attachment.documentTag[i];
        this.uploadedFiles.push({ fileName, size, publicDocument, remarks, documentTag })
      }
      Vue.set(this.form, 'fileAttach', {});
      this.$refs.fitFileUpload.unlockFiles();
    },
    uploadFile() {
      var files = this.$refs.fitFileUpload.formUploadFiles()
      Vue.set(this, 'fileAttach', files);
      return files;
    },
    onClickModal(evt) {
      if (!evt) {
        return;
      }
      console.debug(this.action);
      switch (this.action) {
        case 'next':
          this.onNext();
          break;
        case 'approve':
          this.onApprove();
          break;
        case 'reject':
          this.onReject();
          break;
        case 'complete':
          this.onComplete();
          break;
        case 'edit':
          this.onEdit();
          break;
        case 'saveResult':
          this.onSaveResult(this.selectedResult);
          break;
        case 'createResult':
          this.onCreateResult(this.selectedResult);
          break;
      }
      FITValidationBus.$emit('reset',true);
    },
  },
  props: {
    detail: {
      type: Object,
      default: null
    },
  },
  computed: {
    ...mapGetters(['getTranslatedArray']),
    ...mapGetters(['getTranslated']),
    ...mapState('Claim', ['nextStep', 'claimEventID']),
    permissionLevel(){
      return this.$store.state.permissionLevel;
    },
    orProps() {
      return {
        policyType: 'E',
        policyID: this.claimEventID,
      }
    },
    columnWidth() {
      return 8;
    },
    alertContent() {
      switch (this.alertParams.variant) {
        case 'success':
          return `<i class="fas fa-check-circle"></i> ${this.alertParams.content}`;
        case 'danger':
          return `<i class="fas fa-check-circle"></i> ${this.alertParams.content}`;
        default:
          return this.alertParams.content;
      }
    },
    header() {
      return this.$t(`osm.claim.create.workflow-${this.nextStep+1}`);
    },
    modalTitle() {
      var action = this.action;
      if (action == 'next') {
        action = 'create'
      }
      return this.$t(`general.CURD.${action}`)
    },
    modalBody() {
      var action = this.action;
      if (action == 'saveResult' || action == 'createResult') {
        return this.$t('osm.claim.create.claimResultModal', { action: this.$t(`osm.claim.create.${action}`) });
      }
      if (action == 'next') {
        action = 'create'
      }
      return this.$t('osm.claim.create.confirmModal', { action: this.$t(`general.CURD.${action}`) });
    },
    claimPaymentMethodList() {
      return this.getTranslated(this.$i18n.locale, 'Claim', 'claimPaymentMethod');
    },
    policyType() {
      return this.getTranslatedContent('policyType', this.form.policyType);
    },
    claimTypeList() {
      return this.getTranslated(this.$i18n.locale, 'Claim', 'claimType');
    }
  },
  data() {
    return {
      validation:{
        applyClaim:{
          claimType:false, expectedClaimAmount: false, claimRequestDate:false
        },
        pending:{
          claimResponseDate:false,
        },
        claimDetail:{},
        claimResult:{
          claimIssueDate:false, claimPaymentMethod: false,
          agentReceiveDate:false, customerReceiveDate: false, companyReceiveDate:false,
          claimAmount:false, claimReference:false
        },
      },
      alertParams: {
        content: '<strong>Success</strong>',
        variant: 'success'
      },
      isLocked: true,
      isUploadedNewFile: false,
      action: 'next',
      workflow: [
        { name: this.$t('osm.claim.create.workflow-1') },
        { name: this.$t('osm.claim.create.workflow-2') },
        { name: this.$t('osm.claim.create.workflow-3') },
      ],
      policyName: '',
      fileAttach: {
        attachment: {},
        files: {}
      },
      form: {
        policyID: 0,
        policyType: null,
        claimType: null,
        remark: '',
        expectedClaimAmount: 0,
        claimRequestDate: '',
      },
      pendingForm: {
        claimResponseDate: ''
      },
      resultForm: {
        companyReceiveDate: '',
      },
      claimResults: [],
      claimResultRules:{
        claimIssueDate:{ field:'claimIssueDate', rule:{required:true}, vuexObject:'claimResult'},
        claimPaymentMethod:{ field:'claimPaymentMethod', rule:{required:true}, vuexObject:'claimResult'},
        companyReceiveDate:{ field:'companyReceiveDate', rule:{required:true}, vuexObject:'claimResult'},
        agentReceiveDate:{ field:'agentReceiveDate', rule:{required:true}, vuexObject:'claimResult'},
        customerReceiveDate:{ field:'customerReceiveDate', rule:{required:true}, vuexObject:'claimResult'},
        claimAmount:{ field:'claimAmount', rule:{required:true, decimal:true}, vuexObject:'claimResult'},
        claimReference:{ field:'claimReference', rule:{required:true}, vuexObject:'claimResult'},
      },
      uploadedFiles: [],
      defaultClaimResult: {
        claimPaymentMethod: 'CHE',
        claimIssueDate: '',
        claimReference: '',
        claimAmount: '',
        companyReceiveDate: '',
        agentReceiveDate: '',
        customerReceiveDate: '',
        remark: '',
      },
      selectedResult: -1,
    }
  },

  watch: {
    nextStep(val, old) {
      let diff = old - val;

      if (diff > 0) { // prev
        for (let i = 0; i < diff; i++) {
          this.$refs.progressBar.prevTab();
        }
      } else {
        diff = diff * -1;
        for (let i = 0; i < diff; i++) {
          this.$refs.progressBar.nextTab();
        }
      }
    // this.getValidationRule(val);
    }
  },
  filters: {
    isUndifined: function(value) {
      return value ? value : ''
    }
  },
  destroyed() {
    this.$store.commit({ type: 'Claim/setNextWorkFlowStep', nextStep: 0 });
  }
}

</script>



// WEBPACK FOOTER //
// src/Osm/Claim/containers/ClaimCreate.vue